import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import * as faceapi from 'face-api.js';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DOCUMENT } from '@angular/common';
import { Dialog } from '@angular/cdk/dialog';
import { DialogMychildComponent } from '../Modules/Home/Components/dialog-mychild/dialog-mychild.component';
//import * as tf from '@tensorflow/tfjs';
//import * as cocoSsd from '@tensorflow-models/coco-ssd';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  public userCounts: { [userId: number]: any } = {};
  public BrowserList: any;
  public DeviceList: any;
  private testFileUrl =
    'https://upload.wikimedia.org/wikipedia/commons/3/3f/Fronalpstock_big.jpg'; // ~5MB
  stream!: MediaStream;
  //model: cocoSsd.ObjectDetection | undefined;
  constructor(
    private _http: HttpClient,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _toastr: ToastrService,
    private _deviceService: DeviceDetectorService,
    @Inject(DOCUMENT) private document: any,
    private _dialog: Dialog
  ) {
    this.BrowserList = [
      { Browser: 'chrome', Min_Version: 63 },
      { Browser: 'MS-Edge-Chromium', Min_Version: 62 },
      { Browser: 'MS-Edge', Min_Version: 62 },
      { Browser: 'Edge', Min_Version: 62 },
      { Browser: 'samsung', Min_Version: 12 },
      { Browser: 'opera', Min_Version: 72 },
      { Browser: 'Firefox', Min_Version: 80 },
      { Browser: 'Safari', Min_Version: 5 },
    ];

    this.DeviceList = ['windows', 'mac', 'android'];
  }
  public ExamStatus: BehaviorSubject<boolean> = new BehaviorSubject<any>(false);
  public IP_UserInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public isLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public isShowLeftMenu: BehaviorSubject<boolean> = new BehaviorSubject<any>(
    false
  );
  public PREP_UserInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public formPermission: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public roleId: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  Notification(result: any, message: any) {
    if (result == 'success') this._toastr.success(message);
    else this._toastr.error(message);
  }
  FaceDetections_Message(detections: any) {
    debugger
    if (detections.length == 0)
      return '<strong> Unable to Detect Face: Make Sure</strong> <br>1. Please ensure that your face appears in the camera frame. <br>2. Ensure proper lighting conditions. <br>3. Remove any accessories that may obstruct your face. <br>4. Multiple faces in the camera frame. <br>5. Remove your glasses (if any). <br>6. Your eyes should be clearly visible in the camera frame.';
    else if (detections.length > 1)
      return 'Multiple faces detected in the camera frame.';
    else return "Make sure you're visible in the camera frame.";
  }

  FYearList(): string[] {
    const years: string[] = [];
    for (let Year = 2019; Year <= new Date().getFullYear(); Year++) {
      const start = Year - 1;
      years.push(`${Year}-${(Year + 1).toString().slice(-2)}`);
    }
    return years;
  }
  // GetCameraList(): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       var _list: any = []
  //       navigator.mediaDevices.enumerateDevices().then(function (devices) {

  //         for (var i = 0; i < devices.length; i++) {
  //           var device = devices[i];
  //           if (device.kind === 'videoinput') {
  //             var value = device.deviceId;
  //             var text = device.label || 'camera ' + (i + 1);
  //             _list.push({
  //               value: value,
  //               text: text
  //             })

  //           }
  //         };
  //         resolve(_list);
  //         //return _list;
  //       });
  //       resolve(_list);
  //       //return _list;
  //     }
  //     catch (e) {

  //     }
  //   });

  // }

  GetCameraList(): Promise<{ value: string; text: string }[]> {
    return navigator.mediaDevices
      .enumerateDevices()
      .then((devices) =>
        devices
          .filter((device) => device.kind === 'videoinput')
          .map((device, index) => ({
            value: device.deviceId,
            text: device.label || `Camera ${index + 1}`,
          }))
      )
      .catch((error) => {
        console.error('Error getting camera list:', error);
        return [];
      });
  }

  SubjectLists(): any {
    var subjectList = [
      {
        classId: 1,
        className: 'Class 1',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },

        ],
      },
      {
        classId: 2,
        className: 'Class 2',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },
      {
        classId: 3,
        className: 'Class 3',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },
      {
        classId: 4,
        className: 'Class 4',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },
      {
        classId: 5,
        className: 'Class 5',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },
      {
        classId: 6,
        className: 'Class 6',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },
      {
        classId: 7,
        className: 'Class 7',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },
      {
        classId: 8,
        className: 'Class 8',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },
      {
        classId: 9,
        className: 'Class 9',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },

      {
        classId: 10,
        className: 'Class 10',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'General Knowledge', eventLetter: 'G' },
          { subjectName: 'Hindi', eventLetter: 'H' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },
          { subjectName: 'Social Studies', eventLetter: 'D' },
          { subjectName: 'STEM', eventLetter: 'P' },
          { subjectName: 'Talent Hunt', eventLetter: 'T' },
        ],
      },
      {
        classId: 11,
        className: 'Class 11',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' },

        ],
      },
      {
        classId: 12,
        className: 'Class 12',
        subjectList: [
          { subjectName: 'Computer', eventLetter: 'I' },
          { subjectName: 'English', eventLetter: 'E' },
          { subjectName: 'Maths', eventLetter: 'M' },
          { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
          { subjectName: 'Science', eventLetter: 'S' }

        ],
      },
      {
        classId: 13,
        className: 'Class LKG',
        subjectList: [
          { subjectName: 'Little Star English', eventLetter: 'B' },
          { subjectName: 'Little Star EVS', eventLetter: 'C' },
          { subjectName: 'Little Star Hindi', eventLetter: 'J' },
          { subjectName: 'Little Star Maths', eventLetter: 'A' }
        ],
      },
      {
        classId: 14,
        className: 'Class UKG',
        subjectList: [
          { subjectName: 'Little Star English', eventLetter: 'B' },
          { subjectName: 'Little Star EVS', eventLetter: 'C' },
          { subjectName: 'Little Star Hindi', eventLetter: 'J' },
          { subjectName: 'Little Star Maths', eventLetter: 'A' }
        ],
      },
      {
        classId: 15,
        className: 'Class Nursery',
        subjectList: [
          { subjectName: 'Little Star English', eventLetter: 'B' },
          { subjectName: 'Little Star EVS', eventLetter: 'C' },
          { subjectName: 'Little Star Hindi', eventLetter: 'J' },
          { subjectName: 'Little Star Maths', eventLetter: 'A' }
        ],
      },
    ];
    return subjectList;
  }

  // SubjectList(): any[] {
  //   return [
  //     { subjectName: 'Computer', eventLetter: 'I' },
  //     { subjectName: 'Math', eventLetter: 'M' },
  //     { subjectName: 'Science', eventLetter: 'S' },
  //     { subjectName: 'English', eventLetter: 'E' },
  //     { subjectName: 'Hindi', eventLetter: 'H' },
  //     { subjectName: 'Talent Hunt', eventLetter: 'T' },
  //     { subjectName: 'General Knowledge', eventLetter: 'G' },
  //     { subjectName: 'Social Studies', eventLetter: 'D' },
  //     { subjectName: 'Reasoning & Aptitude', eventLetter: 'R' },
  //     { subjectName: 'STEM', eventLetter: 'P' },
  //     { subjectName: 'Little Star EVS', eventLetter: 'C' },
  //     { subjectName: 'Little Star Hindi', eventLetter: 'J' },
  //   ];
  // }

  // FYear(): string {
  //   return `${new Date().getFullYear()}-${(new Date().getFullYear() + 1)
  //     .toString()
  //     .slice(-2)}`;
  // }


  FYear(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    if (month >= 4) {
      return `${year}-${(year + 1).toString().slice(-2)}`;
    } else {
      return `${year - 1}-${year.toString().slice(-2)}`;
    }
  }


  testDownloadSpeed(): Promise<number> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const startTime = new Date().getTime();
      let loaded = false;

      image.onload = () => {
        if (!loaded) {
          loaded = true;
          const endTime = new Date().getTime();
          const durationInSeconds = (endTime - startTime) / 1000;
          const bitsLoaded = 5 * 1024 * 1024 * 8; // Approx size in bits
          const speedBps = bitsLoaded / durationInSeconds;
          const speedMbps = speedBps / (1024 * 1024); // convert to Mbps
          resolve(Number(speedMbps.toFixed(2)));
        }
      };
      image.onerror = () => reject('Failed to load test file');

      // Add random query to prevent caching
      image.src = `${this.testFileUrl}?cacheBust=${Math.random()}`;
    });
  }

  get_Login_Status() {
    var _UserInfo = this.Get_PREP_UserInfo();
    if (_UserInfo != null) {
      this._checkTodayIsLogin(_UserInfo);
    }

    return this.IP_UserInfo.asObservable();
  }
  _checkTodayIsLogin(_UserInfo: any): boolean {
    if (JSON.parse(_UserInfo).loginDate != new Date().toLocaleDateString()) {
      if (typeof window !== 'undefined' && window.localStorage)
        // localStorage.clear();
        localStorage.removeItem('PREP_UserInfo');
      localStorage.removeItem('token');
      this.IP_UserInfo.next(null);
      return false;
    } else {
      this.IP_UserInfo.next(JSON.parse(_UserInfo));
      return true;
    }
  }

  fullScreen() {
    if (this.document.documentElement.requestFullscreen) {
      this.document.documentElement.requestFullscreen();
    } else if (this.document.documentElement.mozRequestFullScreen) {
      /* Firefox */
      this.document.documentElement.mozRequestFullScreen();
    } else if (this.document.documentElement.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitRequestFullscreen();
    } else if (this.document.documentElement.msRequestFullscreen) {
      /* IE/Edge */
      this.document.documentElement.msRequestFullscreen();
    }
  }

  closeFullscreen() {
    if (this.document.documentElement.exitFullscreen) {
      this.document.documentElement.exitFullscreen();
    } else if (this.document.documentElement.mozCancelFullScreen) {
      /* Firefox */
      this.document.documentElement.mozCancelFullScreen();
    } else if (this.document.documentElement.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.documentElement.webkitExitFullscreen();
    } else if (this.document.documentElement.msExitFullscreen) {
      /* IE/Edge */
      this.document.documentElement.msExitFullscreen();
    }
  }

  Get_ExamStatus() {
    return this.ExamStatus.asObservable();
  }

  Set_ExamStatus(_examStatus: boolean) {
    this.ExamStatus.next(_examStatus);
  }

  Switch_Child(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._dialog
        .open(DialogMychildComponent, {
          data: null,
        })
        .closed.subscribe((res: any) => {
          return resolve(res);
        });
    });
  }

  check_Login_Status(returnURL: any): boolean {
    const _UserInfo = this.Get_PREP_UserInfo();
    //console.log("UserInfo:", _UserInfo);
    // return true;
    if (!_UserInfo) {
      if (typeof window !== 'undefined') {
        localStorage?.removeItem('PREP_UserInfo');
        localStorage.removeItem('token');
        // localStorage?.clear();
      }

      this.IP_UserInfo.next(null);
      this._router.navigateByUrl('/login?return=' + returnURL);
      return false;
    } else return this._checkTodayIsLogin(_UserInfo);
  }

  check_Login_Status_Only(): boolean {
    var _UserInfo = this.Get_PREP_UserInfo();
    if (_UserInfo == null) {
      return false;
    } else {
      return this._checkTodayIsLogin(_UserInfo);
    }
  }
  Get_PREP_UserInfo() {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('PREP_UserInfo');
    } else return null;
  }

  async imageUrlToBase64(url: string): Promise<string> {
    const response = await fetch(url, { mode: 'cors' });
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob); // Convert blob to base64
    });
  }
  async faceMatchWithBase64(
    sourceImage: string,
    destinationImage: string
  ): Promise<boolean> {
    // Helper to convert base64 to HTMLImageElement

    const base64ToImage = (base64: string): Promise<HTMLImageElement> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = base64;
        img.onload = () => resolve(img);
        img.onerror = (err) => reject('Failed to load image: ' + err);
      });
    };

    try {
      const srcImg = await base64ToImage(sourceImage);
      const dstImg = await base64ToImage(destinationImage);

      // const detections = await detectObjects(dstImg);

      const dstDetection = await faceapi
        .detectSingleFace(dstImg)
        .withFaceLandmarks()
        .withFaceDescriptor();

      const srcDetection = await faceapi
        .detectSingleFace(srcImg)
        .withFaceLandmarks()
        .withFaceDescriptor();

      if (!srcDetection || !dstDetection) {
        console.warn('One or both faces not detected');
        return false;
      }

      const distance = faceapi.euclideanDistance(
        srcDetection.descriptor,
        dstDetection.descriptor
      );

      //console.log('Face match distance:', distance);
      debugger;
      // Adjust threshold as needed (typical ~0.4–0.6)
      return true;//distance <= 0.8;
    } catch (error) {
      console.error('Face match error:', error);
      return false;
    }
  }
  // async ngAfterViewInit() {
  //
  //   setTimeout(async () => {
  //     await this.loadModels();
  //   }, 100);
  // }

  async loadModels(): Promise<void> {
    //await tf.setBackend('webgl'); // or 'cpu' if needed
    //await tf.ready();
    const MODEL_URL = '/assets/models';
    await Promise.all([
      faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
      faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
      faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
    ]);
    //  this.model = await cocoSsd.load();
  }
  openCamera(_camera: any, deviceId?: string): void {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      const constraints: MediaStreamConstraints = {
        video: deviceId
          ? { deviceId: { exact: deviceId } } // may not work on iOS
          : { facingMode: "user" },           // fallback for iPhone
        audio: false,
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream: MediaStream) => {
          this.stream = stream;
          const videoElement: HTMLVideoElement = _camera.nativeElement;

          videoElement.srcObject = stream;

          // iOS Safari fix
          videoElement.setAttribute("playsinline", "true");
          videoElement.setAttribute("autoplay", "true");
          videoElement.muted = true;

          videoElement.play().catch(err => {
            console.error("Autoplay prevented:", err);
          });
        })
        .catch((err) => {
          console.error("Error accessing camera:", err);
          //alert(JSON.stringify(err));
        });
    } else {
      console.warn("Camera API not supported in this browser.");
    }
  }


  // openCamera(_camera: any, deviceId?: string): void {
  //   if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  //     const constraints: MediaStreamConstraints = {
  //       video: deviceId ? { deviceId: { exact: deviceId } } : true,
  //       audio: false,
  //     };

  //     navigator.mediaDevices
  //       .getUserMedia(constraints)
  //       .then((stream: MediaStream) => {
  //         this.stream = stream;
  //         _camera.nativeElement.srcObject = stream;
  //         _camera.nativeElement.play();
  //       })
  //       .catch((err) => {
  //         console.error('Error accessing camera:', err);
  //         alert(JSON.stringify(err));
  //       });
  //   } else {
  //     console.warn('Camera API not supported in this browser.');
  //   }
  // }
  openCamera1(_camera: any, CameraSource: string): void {
    this.closeCamera();
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: CameraSource } })
        .then((stream: MediaStream) => {
          this.stream = stream;
          _camera.nativeElement.srcObject = stream;

          _camera.nativeElement.play();
        })
        .catch((err) => {
          console.error('Error accessing camera: ', err);
        });
    } else {
      console.warn('Camera API not supported in this browser.');
    }
  }
  closeCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  }

  async captureImage(_canvas: any, _camera: any): Promise<string> {
    const context = _canvas.nativeElement.getContext('2d');
    if (!context) {
      console.error('Canvas context not available');
      return '';
    }

    // Set canvas size to video dimensions
    _canvas.nativeElement.width = _camera.nativeElement.videoWidth;
    _canvas.nativeElement.height = _camera.nativeElement.videoHeight;

    // Draw video frame to canvas
    context.drawImage(
      _camera.nativeElement,
      0,
      0,
      _canvas.nativeElement.width,
      _canvas.nativeElement.height
    );

    // Get base64 image from canvas
    return _canvas.nativeElement.toDataURL('image/png');
    //console.log('Captured Image:', this.capturedImage);
  }

  resizeBase64Image(
    base64Str: string,
    maxWidth: number,
    maxHeight: number
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64Str;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        // Maintain aspect ratio
        const ratio = Math.min(maxWidth / img.width, maxHeight / img.height);
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Export back to Base64 (JPEG or PNG)
        const resizedBase64 = canvas.toDataURL('image/jpeg', 0.9); // 0.9 = quality
        resolve(resizedBase64);
      };

      img.onerror = (err) => reject(err);
    });
  }

  DeviceInfo() {
    return {
      os: this._deviceService.os,
      os_version: this._deviceService.os_version,
      device: this._deviceService.device,
      deviceType: this._deviceService.deviceType,
      browser_version: this._deviceService.browser_version,
      browser: this._deviceService.browser,
    };
  }

  logout(returnurl: any) {
    localStorage.removeItem('PREP_UserInfo');
    localStorage.removeItem('token');
    this.IP_UserInfo.next(null);
    this.PREP_UserInfo.next(null);
    this._router.navigate(['/']);
  }

  Show_Loader() {
    this.isLoader.next(true);
  }

  Hide_Loader() {
    this.isLoader.next(false);
  }

  uniqueBy(array: any, key: any) {
    const arrayUniqueByKey = [
      ...new Map(array.map((item: any) => [item[key], item])).values(),
    ];

    return arrayUniqueByKey;
  }

  POST(_model: any, url: string): Observable<any> {
    return this._http.post(environment.baseURL + url, _model).pipe(
      catchError((err) => {
        let errorMsg: string;
        if (err.error instanceof ErrorEvent) {
          errorMsg = `Error: ${err.error.message}`;
        } else {
          errorMsg = this.getServerErrorMessage(err);
        }
        return of({ result: 'error', message: errorMsg });
      }),
      map((response) => response)
    );
  }

  GET(url: string): Observable<any> {
    return this._http.get(environment.baseURL + url).pipe(
      catchError((err) => {
        let errorMsg: string = '';
        if (typeof ErrorEvent !== 'undefined') {
          if (err.error instanceof ErrorEvent) {
            errorMsg = `Error: ${err.error.message}`;
          } else {
            errorMsg = this.getServerErrorMessage(err);
          }
        }

        return of({ result: 'error', message: errorMsg });
      }),
      map((response) => response)
    );
  }

  getPdfUrl(id: string): string {
    return `${environment.pdfBaseUrl}${id}.pdf`;
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
      case 401: {
        this._router.navigate(['/']);
        return `Not Found: ${error.message}`;
      }
      case 404: {
        return `Not Found: ${error.message}`;
      }
      case 403: {
        return `Access Denied: ${error.message}`;
      }
      case 500: {
        return `Internal Server Error: ${error.message}`;
      }
      default: {
        return `Unknown Server Error: ${error.message}`;
      }
    }
  }

  get nativeWindow(): Window {
    return window;
  }

  updateChildInfo(child: any) {
    let userInfo = JSON.parse(localStorage.getItem('PREP_UserInfo') || '{}');
    if (userInfo) {
      userInfo.childId = child.StudentId;
      userInfo.childName = child.childName;
      userInfo.classId = child.ClassId;
      userInfo.profilePic = child.Photo;
      userInfo.className = child.className;
    }
    localStorage.setItem('PREP_UserInfo', JSON.stringify(userInfo));
    this.PREP_UserInfo.next(userInfo);
  }
  getUserInfo() {
    return this.PREP_UserInfo.asObservable();
  }
  GenerateUniqueID() {
    const navigator_info = window.navigator;
    const screen_info = window.screen;

    var uid = '';

    // userAgent is allowed in iOS Safari
    uid += navigator_info.userAgent.replace(/\D+/g, '');

    // screen width/height & pixelDepth are stable
    uid += screen_info.width + 'x' + screen_info.height;
    uid += screen_info.pixelDepth || '';

    // browser/device info from your service if available
    if (this._deviceService?.browser_version) {
      uid += this._deviceService.browser_version;
    }
    if (this._deviceService?.deviceType) {
      uid += this._deviceService.deviceType;
    }

    // var navigator_info = window.navigator;
    // var screen_info = window.screen;
    // var uid = '' + navigator_info.mimeTypes.length;

    // uid += navigator_info.userAgent.replace(/\D+/g, '');
    // uid += navigator_info.plugins.length;
    // uid += this._deviceService.browser_version;
    // uid += this._deviceService.deviceType;
    // uid += screen_info.pixelDepth || '';
    return uid;
  }
}
